export default __webpack_public_path__ + "static/media/element_10.555ed141.jpg";